import { Reducer } from 'redux';
import { ActionType, createStandardAction, getType } from 'typesafe-actions';
import { prepareDates } from 'src/comps/Inspector/DateRangeInspector/DateRangeMenuItems';
import menuItems from 'src/comps/Inspector/DateRangeInspector/DateRangeMenuItems';
import { GetTimeRange } from 'src/comps/UserProfile/UserProfile';

export type InitializeArgs = { clientId: string; tenantId: string };

export const dateRangeSelectorActions = {
  updateDateRange: createStandardAction('@dateRangeSelector/updateDateRange')<{
    fromDate: Date;
    untilDate: Date;
    mode: string;
    itemText: string;
    page: string;
  }>(),

  clearDateRange: createStandardAction('@dateRangeSelector/clearDateRange')<any>(),

  openDateRangeInspector: createStandardAction('@inspector/openDateRangeInspector')<{
    source: any;
    page: string;
    mode: string;
    itemText: string;
    fromDate: Date;
    untilDate: Date;
    openTimeFrame: boolean;
  }>(),
  closeTimeFrame: createStandardAction('@inspector/closeTimeFrame')<any>(),
};

export type DateRangeSelectorActions = ActionType<typeof dateRangeSelectorActions>;

export type DateRangeSelectorState = {
  readonly fromDate: Date;
  readonly untilDate: Date;
  readonly itemText: string;
  readonly page: string;
  readonly mode: string;
  readonly source: any;
  readonly openTimeFrame: boolean;
};

export type RootState = { dateRangeSelector: DateRangeSelectorState };

const timeRange = GetTimeRange();
const fromToDates = prepareDates(timeRange);

export const dateRangeSelectorInitialState: DateRangeSelectorState = {
  fromDate: fromToDates.startDate,
  untilDate: fromToDates.endDate,
  itemText: menuItems.get(timeRange) ?? '',
  page: '',
  mode: timeRange,
  source: null,
  openTimeFrame: false,
};

export const dateRangeSelector: Reducer<DateRangeSelectorState, DateRangeSelectorActions> = (
  state = dateRangeSelectorInitialState,
  action,
) => {
  switch (action.type) {
    case getType(dateRangeSelectorActions.updateDateRange): {
      return { ...state, ...action.payload };
    }
    case getType(dateRangeSelectorActions.clearDateRange): {
      const localTimeRange = GetTimeRange();
      const localFromToDates = prepareDates(localTimeRange);
      return {
        ...state,
        fromDate: localFromToDates.startDate,
        untilDate: localFromToDates.endDate,
        itemText: menuItems.get(localTimeRange) ?? '',
        page: '',
        mode: localTimeRange,
        source: null,
        openTimeFrame: false,
      };
    }
    case getType(dateRangeSelectorActions.openDateRangeInspector): {
      return {
        ...state,
        page: action.payload.page,
        itemText: action.payload.itemText,
        mode: action.payload.mode,
        fromDate: action.payload.fromDate,
        untilDate: action.payload.untilDate,
        source: action.payload.source,
        openTimeFrame: action.payload.openTimeFrame,
      };
    }
    case getType(dateRangeSelectorActions.closeTimeFrame): {
      return { ...state, openTimeFrame: false };
    }
    default: {
      return state;
    }
  }
};

export const dateRangeSelectors = {
  fromDate: (state: RootState) => state.dateRangeSelector.fromDate,
  untilDate: (state: RootState) => state.dateRangeSelector.untilDate,
  itemText: (state: RootState) => state.dateRangeSelector.itemText,
  page: (state: RootState) => state.dateRangeSelector.page,
  mode: (state: RootState) => state.dateRangeSelector.mode,
  source: (state: RootState) => state.dateRangeSelector.source,
  openTimeFrame: (state: RootState) => state.dateRangeSelector.openTimeFrame,
};
